<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    :persistent="options.persistent"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="headline py-1">
        {{ heading }}
      </v-card-title>
      <v-divider class="my-0" />
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-layout row wrap v-if="options.threeButtonVaraint">
          <v-spacer />
          <v-flex xs3>
            <v-btn
              :color="options.cancelColor"
              flat
              text
              class="three-button-variant"
              @click.native="cancel"
            >
              {{ $t('message.stay') }}
            </v-btn>
          </v-flex>
          <v-flex xs3>
            <v-btn
              :color="options.confirmColor"
              flat
              text
              class="three-button-variant"
              @click.native="confirm"
            >
              {{ $t('message.leave') }}
            </v-btn>
          </v-flex>
          <v-flex xs5>
            <v-btn
              :color="options.saveAndContinueColor"
              flat
              text
              class="three-button-variant"
              @click.native="saveAndContinue"
            >
              {{ $t('message.saveAndContinue') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-else>
          <v-btn
            :color="options.confirmColor"
            flat
            text
            @click.native="confirm"
          >
            {{ $t('message.yes') }}
          </v-btn>
          <v-btn
            :color="options.cancelColor"
            flat
            text
            @click.native="cancel"
          >
            {{ $t('message.no') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Inside template
 * <app-promise-dialog ref="yourdialogname"></app-promise-dialog>
 *
 * Inside script
 * Normal way:
 * this.$refs.yourdialogname.open('Heading', 'Are you sure?', { confirmColor: 'primary',persistent:true }).then((response) => {})
 *
 * Using await:
 * if (await this.$refs.confirm.open('Heading', 'Are you sure?', { confirmColor: 'primary' })) {
 *   // yes
 * }
 * else {
 *   // no
 * }
 */
import {
  VDialog,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VBtn,
  VDivider,
  VLayout,
  VFlex
} from 'vuetify/lib';
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    heading: null,
    options: {
      saveAndContinue: 'primary',
      confirmColor: 'primary',
      cancelColor: 'error',
      persistent: false,
      threeButtonVaraint: false
    }
  }),
  methods: {
    open(heading, message, options) {
      this.dialog = true;
      this.heading = heading;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    saveAndContinue() {
      this.resolve({ saveAndContinue: true, continue: false });
      this.dialog = false;
    },
    confirm() {
      if (this.options.threeButtonVaraint) {
        this.resolve({ saveAndContinue: false, continue: true });
      } else {
        this.resolve(true);
      }
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  },
  components: {
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VBtn,
    VDivider,
    VLayout,
    VFlex
  }
};
</script>
<style>
  @media screen and (max-width: 480px) {
    .three-button-variant{
    min-width: 0vw!important;
    padding: 3vw !important;
   }
 }
</style>